import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface ProspectedBadgeProps {
  prospected: boolean;
}

const ProspectedBadge: React.FC<ProspectedBadgeProps> = ({ prospected }) => {
  const { t } = useTranslation();
  const text = prospected ? t('dashboard.prospected_yes') : t('dashboard.prospected_no');
  const color = prospected 
    ? { bg: 'bg-blue-100 dark:bg-blue-900/50', text: 'text-blue-700 dark:text-blue-300', dot: 'bg-blue-500' }
    : { bg: 'bg-gray-100 dark:bg-gray-700/50', text: 'text-gray-700 dark:text-gray-300', dot: 'bg-gray-500' };

  return (
    <motion.span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${color.bg} ${color.text}`}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 500, damping: 30 }}
    >
      <motion.span
        className={`size-1.5 rounded-full ${color.dot}`}
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 2, repeat: Infinity }}
      />
      {text}
    </motion.span>
  );
};

export default ProspectedBadge;